/* Size & fit data — pulled from the Shopify "Size & Fit" pages (Sept 23, 2026).
   Garment measurements are flat, in inches. `fit` = position on the Small→Large slider (0–100). */
window.FIT = {
  'body': {
    cols: ['Size', 'Bust', 'Waist', 'Hip'],
    rows: [
      ['XS', '32–33', '24–25', '34–35'],
      ['S', '34–35', '26–27', '36–37'],
      ['M', '36–37½', '28–29½', '38–39½'],
      ['L', '39–40½', '31–32½', '41–42½']
    ],
    note: 'Body measurements — the body each size is cut to fit, not the garment. Between two sizes? Size up for more drape, down for a closer fit.'
  },
  'shea': {
    label: 'The Shea T-Shirt Dress',
    fit: 50, note: 'True to size. Skims the body — size up for a looser drape.',
    cols: ['', 'XS', 'S', 'M', 'L'],
    rows: [['Bust', '34', '35', '36', '37'], ['Waist', '29', '30', '31', '32'], ['Hip', '34', '35', '36', '37'], ['Length', '54', '55¼', '56', '56¾']]
  },
  'beach-shirt': {
    label: 'The Button-Up Beach Tunic',
    fit: 74, note: 'Cut oversized on purpose. Take your usual size, or size down for a closer fit.',
    cols: ['', 'XS', 'S', 'M', 'L'],
    rows: [['Bust', '40.4', '42', '43.6', '45.2'], ['Length', '30.8', '31.4', '32.1', '32.7'], ['Sleeve', '20.8', '21.2', '21.6', '22']]
  },
  'landon': {
    label: 'The New Landon Tank',
    fit: 50, note: 'True to size. Full through the body, so choose on bust.',
    cols: ['', 'XS', 'S', 'M', 'L'],
    rows: [['Bust', '37.8', '39.4', '41', '42.6'], ['Length', '15.7', '16.1', '16.5', '16.9']]
  },
  'kaitlin': {
    label: 'The Kaitlin Pants',
    fit: 50, note: 'True to size at the waist. High rise, in a regular or long inseam.',
    cols: ['', 'XS', 'S', 'M', 'L'],
    rows: [['Waist', '26', '27.6', '29.2', '30.8'], ['Hip', '39.4', '41', '42.6', '44.2'], ['Inseam', '30', '30¼', '30½', '30¾']]
  },
  'vacation': {
    label: 'The Vacation Pant',
    fit: 60, note: 'Elastic waist with plenty of give — choose on hip.',
    cols: ['', 'XS', 'S', 'M', 'L'],
    rows: [['Waist', '27', '28.6', '30.2', '31.8'], ['Hip', '47.4', '49', '50.6', '52.2'], ['Inseam', '33', '34', '35', '36']]
  },
  'asher': {
    label: 'The Asher Shorts',
    fit: 50, note: 'True to size. The elastic waist gives about 10 in of stretch.',
    cols: ['', 'XS', 'S', 'M', 'L'],
    rows: [['Waist', '26.8', '28.4', '30', '31.6'], ['Hip', '38.6', '40.2', '41.8', '43.4'], ['Inseam', '2.6', '2.8', '3', '3.2']]
  },
  'bridgett': {
    label: 'The Bridgett Skirt',
    fit: 50, note: 'True to size at the waist. Size up if you are fuller through the hip.',
    cols: ['', 'XS', 'S', 'M', 'L'],
    rows: [['Waist', '26', '27.6', '29.2', '30.8'], ['Hip', '37.8', '39.4', '41', '42.6'], ['Length', '43', '45.3', '46.5', '47.6']]
  }
};
